module.exports = __webpack_public_path__ + "static/media/Värde-Baserat Ledarskap.5aa33ee7.pdf";